import { render, staticRenderFns } from "./BrandItem.vue?vue&type=template&id=6da1e31a&scoped=true&"
import script from "./BrandItem.vue?vue&type=script&lang=ts&"
export * from "./BrandItem.vue?vue&type=script&lang=ts&"
import style0 from "./BrandItem.vue?vue&type=style&index=0&id=6da1e31a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da1e31a",
  null
  
)

export default component.exports